
import { protectedRoutes } from "./protected.routes"
import { publicRoutes } from "./public.routes"
import { authRoutes } from "./auth.routes"

export {
    publicRoutes,
    protectedRoutes,
    authRoutes
}